import { render, staticRenderFns } from "./ContactCollapse.vue?vue&type=template&id=2403867c&"
import script from "./ContactCollapse.vue?vue&type=script&lang=js&"
export * from "./ContactCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ContactCollapse.vue?vue&type=style&index=0&id=2403867c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports